export default {"src":"/_next/static/media/term-email.c0ec20f3.svg","height":49,"width":45,"blurWidth":0,"blurHeight":0};